import {Fragment} from "react";
import AppBox from "../Box";
import {AppDivider, AppSkeleton} from "../index";

export default function AvatarLabelSkeleton({count = 1}: { count?: number }) {
    return (
        <>
            {[...Array(count)].map((_, index) => (
                <Fragment key={index}>
                    <AppBox alignItems={'center'} gap={'xs'} p={'xs'}>
                        <AppBox displayBlock>
                            <AppSkeleton type={'avatar-md'}/>
                        </AppBox>
                        <AppSkeleton type={'text'}/>
                    </AppBox>
                    {index < count - 1 && <AppDivider/>}
                </Fragment>
            ))}
        </>
    )
}